import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=8987f578&scoped=true&"
import script from "./BrandLogo.vue?vue&type=script&lang=js&"
export * from "./BrandLogo.vue?vue&type=script&lang=js&"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=8987f578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8987f578",
  null
  
)

export default component.exports